<template>
  <div class="min-h-screen ">
    <div class="max-w-7xl mx-auto mb-2">
      <div class="bg-white rounded-2xl shadow p-2 sm:p-2">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2 lg:flex-row lg:items-center">
          <div class="grid grid-cols-1 md:grid-cols-3">
            <div class="relative col-span-2 flex w-full">
              <label for="auction-link" class="sr-only">Вставте посилання на лот</label>
              <input
                  id="auction-link"
                  class="w-full px-4 py-3 pr-12 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition"
                  type="text"
                  @keyup.enter="parseLink"
                  v-model.trim="link"
                  placeholder="https://www.copart.com/lot/40166173"
                  autocomplete="off"
                  inputmode="url"
              />
              <button
                  type="button"
                  @click="clearCar()"
                  class="absolute right-3 top-1/2 -translate-y-1/2 inline-flex items-center justify-center w-8 h-8 rounded-lg text-gray-500 hover:text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary"
                  aria-label="Очистити поле"
              >
                <ClearIcon/>
              </button>
            </div>
            <custom-btn @click="parseLink" :title="'Сканувати'"/>
          </div>

          <div v-if="user.email === 'simple_manager@liontrans.com'" class="w-full lg:w-80">
            <div class="text-base font-medium text-m text-gray-700 mb-2">Оберіть ділера:</div>
            <vue-select
                @change="changeDealer"
                v-model="selectedDealer"
                :options="dealers"
                label="email"
                class="w-full"
            />
          </div>

          <div class="flex items-center gap-3 lg:ml-auto">
            <span class="text-base font-medium text-gray-700">Поділитися результатом:</span>
            <ShareIcons @share="share"/>
          </div>
        </div>
      </div>
    </div>

    <div class="max-w-7xl mx-auto mb-2">
      <div class="flex bg-white rounded-xl p-1 shadow-sm">
        <button
            type="button"
            :class="[
            'flex-1 px-4 py-2 text-base rounded-lg transition text-black font-bold',
            isSubMenu === 'calculator' ? 'bg-red-600 text-white shadow' : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
          ]"
            @click="changeMenu('calculator')"
        >
          Калькулятор Авто
        </button>
        <button
            type="button"
            :class="[
            'flex-1 px-4 py-2 text-base font-medium rounded-lg transition flex items-center justify-center gap-2',
            isSubMenu === 'analytics' ? 'bg-red-600 text-white shadow' : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
          ]"
            @click="changeMenu('analytics')"
        >
          Аналітика Авто
          <i v-if="analyticsLoading" class="animate-spin fa fa-solid fa-spinner text-sm" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <div class="max-w-7xl mx-auto" v-if="isSubMenu === 'calculator'">
      <div class="grid grid-cols-1 gap-2 lg:gap-4 lg:grid-cols-2">
        <div class="space-y-6">
          <div class="bg-white rounded-2xl shadow p-2">
            <h3 class="text-base sm:text-lg font-semibold text-red-600 mb-4">
              Тимчасові додаткові платежі
            </h3>

            <div class="mb-4 min-h-[4.5rem]">
              <div v-if="msg !== ''">
                <div
                    :class="[
                      'text-left prose prose-sm max-w-none text-gray-700 transition-all duration-500 ease-in-out',
                      openFullText ? 'max-h-[400px] overflow-scroll' : 'max-h-[200px]'
                    ]"
                    v-html="openFullText ? msgF : msg"
                ></div>
              </div>
              <div v-else>
                <Skeleton class="msg-waiting" :count="4"/>
              </div>
            </div>

            <button
                type="button"
                @click="toggleFullText"
                class="cursor-pointer text-primary hover:text-primary/80 font-medium text-sm transition-colors duration-200"
            >
              <span v-if="!openFullText">Переглянути всі зміни</span>
              <span v-else>Сховати повні зміни</span>
            </button>
          </div>

          <div class="bg-white overflow-hidden p-2">
            <div class="overflow-hidden p-2">
              <div v-if="!loader && images.length > 0" class="grid grid-cols-4 grid-rows-2 gap-2 h-40">
                <div class="col-span-2 row-span-2 overflow-hidden rounded-xl">
                  <img
                      :src="images[0]"
                      alt="Главное фото авто"
                      class="w-full h-full object-cover"
                  />
                </div>

                <div
                    v-for="(image, index) in images.slice(1, 5)"
                    :key="index"
                    class="overflow-hidden rounded-lg"
                >
                  <img
                      :src="image"
                      :alt="`Фото авто ${index + 2}`"
                      class="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div v-else-if="loader" class="h-40 grid grid-cols-7 grid-rows-6 gap-1">
                <div
                    v-for="index in 7"
                    :key="index"
                    :class="index === 1 ? 'col-span-3 row-span-6' : 'col-span-2 row-span-3'"
                >
                  <Skeleton class="w-full h-full"/>
                </div>
              </div>

              <div v-else class="h-60 flex flex-col items-center justify-center text-gray-400 ">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-12 h-12 mb-2" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                        d="M3 16l4-4a2 2 0 012.828 0L15 17l4-4a2 2 0 012.828 0L21 16v5H3v-5z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 5h18M9 3v2m6-2v2"/>
                </svg>
                <span class="text-sm">Фото відсутнє</span>
              </div>
            </div>

            <div class="bg-gray-50 p-2 sm:p-5">
              <div class="text-center mb-4 min-h-[24px]">
                <h2 v-if="!loader" class="text-lg sm:text-xl font-semibold text-gray-900 truncate">{{ car.name }}</h2>
                <Skeleton v-else height="25px"/>
              </div>

              <div class="space-y-3">
                <div v-if="!loader" class="flex items-center justify-between relative">
                  <div class="px-2 py-1 text-base font-medium text-gray-900">
                    {{ car.engType !== 'ELECTRIC' ? 'Об\'єм двигуна' : 'КВт/Ч' }}
                  </div>
                  <div class="absolute inset-x-0 bottom-0 border-b border-gray-200"></div>
                  <div class="px-2 py-1">
                    <input
                        v-if="car.engType !== 'ELECTRIC'"
                        class="bg-transparent border-none w-24 text-right text-base font-medium text-gray-900 focus:outline-none transition-all duration-300"
                        :class="{
      'ring-2 ring-red-500 shadow-[0_0_10px_rgba(239,68,68,0.5)] bg-red-50 rounded-lg px-2 animate-pulse': car.isMoto && (!car.capacity || car.capacity == 0)
    }"
                        type="text"
                        v-model="car.capacity"
                        @change="getCustomClearance"
                        placeholder="0"
                        inputmode="decimal"
                    />
                    <input
                        v-else
                        class="bg-transparent border-none w-20 text-right text-base font-medium text-gray-900 focus:outline-none"
                        type="text"
                        v-model="car.capacity"
                        @change="getCustomClearance"
                        inputmode="decimal"
                    />
                  </div>
                </div>
                <Skeleton v-else height="25px"/>

                <div v-if="!loader" class="flex items-center justify-between relative">
                  <div class="px-2 py-1 text-base font-medium text-gray-900">Вид палива</div>
                  <div class="absolute inset-x-0 bottom-0 border-b border-gray-200"></div>
                  <div class="px-2 py-1 text-base font-medium text-gray-900">{{ car.engType }}</div>
                </div>
                <Skeleton v-else height="25px"/>

                <div v-if="!loader" class="flex items-center justify-between relative">
                  <div class="px-2 py-1 text-base font-medium text-gray-900">Статус продажу</div>
                  <div class="absolute inset-x-0 bottom-0 border-b border-gray-200"></div>
                  <div class="px-2 py-1 text-base font-medium text-gray-900">{{ car.saleStatus }}</div>
                </div>
                <Skeleton v-else height="25px"/>

                <div v-if="!loader" class="flex items-center justify-between relative">
                  <div class="px-2 py-1 text-base font-medium text-gray-900">Порт доставки</div>
                  <div class="absolute inset-x-0 bottom-0 border-b border-gray-200"></div>
                  <div class="px-2 py-1 text-base font-medium text-gray-900">Klaipėda</div>
                </div>
                <Skeleton v-else height="25px"/>

                <div v-if="!loader" class="flex items-center justify-between relative">
                  <div class="px-2 py-1 text-base font-medium text-gray-900">Сублот</div>
                  <div class="absolute inset-x-0 bottom-0 border-b border-gray-200"></div>
                  <div class="px-2 py-1 text-base font-medium text-gray-900">
                    {{ car.sublot ? "YES" : "NO" }}
                  </div>
                </div>
                <Skeleton v-else height="25px"/>
              </div>

              <div class="rounded-xl mt-4 p-2" :class="goodDocs ? 'bg-green-50' : 'bg-red-50'">
                <div v-if="!loader" class="space-y-3">
                  <div class="flex items-center justify-between relative">
                    <div class="px-2 py-1 text-base font-medium text-gray-900">Тип документа</div>
                    <div class="absolute inset-x-0 bottom-0"
                         :class="goodDocs ? 'border-b border-green-300' : 'border-b border-amber-600'"></div>
                    <div class="text-left px-2 py-1 text-base font-medium text-gray-900">
                      <strong>{{ car.cert }} <span v-if="car.cert">для експорту із США</span></strong>
                    </div>
                  </div>

                  <div v-if="!car.cert.toLowerCase().includes('good')" class="text-left text-xs text-gray-700">
                    Проблеми з документами можуть спричинити додаткові витрати. Для уточнення інформації зверніться до
                    робочого чату
                  </div>

                  <div class="flex items-center justify-between relative">
                    <div class="px-2 py-1 text-base font-medium text-gray-900">Продавець</div>
                    <div class="absolute inset-x-0 bottom-0"
                         :class="goodDocs ? 'border-b border-green-300' : 'border-b border-amber-600'"></div>
                    <div class="text-left px-2 py-1 text-base font-medium text-gray-900">
                      <span v-if="car.lic">Страхова</span>
                      <span v-else-if="link && car.lic === false && car.renta === false">Дилер</span>
                      <span v-else-if="link">Оренда</span>
                    </div>
                  </div>

                  <div v-if="car.lic === false && car.renta === false" class="text-left text-xs text-gray-700">
                    Будьте уважні! Дилер не є надійною особою. Для уточнення інформації зверніться до робочого чату
                  </div>
                </div>
                <div v-else class="space-y-3">
                  <Skeleton height="25px"/>
                  <Skeleton height="35px"/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="space-y-2">
          <div class="bg-white rounded-2xl shadow p-2">
            <div class="mb-2" v-if="!loader">
              <div class="flex items-center justify-between gap-3">
                <div class="flex items-stretch bg-gray-100 rounded-lg overflow-hidden">
                  <span class="px-3 py-2 text-base font-medium text-gray-700 bg-gray-200">VIN</span>
                  <span class="px-3 py-2 text-base font-medium text-gray-900">{{
                      car.vin_code.length > 0 ? car.vin_code : '-'
                    }}</span>
                  <input
                      type="text"
                      placeholder="Останні цифри"
                      v-model="car.lastFourDigits"
                      maxlength="6"
                      class="bg-white border-l border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
                  />
                </div>
                <button
                    type="button"
                    @click="copyVin"
                    class="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"
                >
                  <CopyIcon/>
                  <span class="text-base font-medium">Копіювати VIN</span>
                </button>
              </div>
            </div>
            <Skeleton v-else height="42px"/>

            <div class="space-y-2">
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-2" v-if="!loader">
                <div class="text-left">
                  <label class="text-base font-medium text-gray-700 mb-2 block">Рік випуску</label>
                  <input
                      type="number"
                      @change="getCustomClearance"
                      placeholder="Рік випуску"
                      v-model.number="car.year"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      inputmode="numeric"
                  />
                  <p class="text-xs text-gray-500 mt-1">Перевірте рік випуску на фото шильдіка</p>
                </div>
                <div class="text-left">
                  <label class="text-base font-medium text-gray-700 mb-2 block">Фінальна ставка, USD</label>
                  <input
                      type="number"
                      @change="() => {
                        calcAuctionFee(link.includes('copart') ? 'copart' : 'iaai')
                        getCustomClearance()
                      }"
                      placeholder="Фінальна ставка USD"
                      v-model.number="car.price"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      inputmode="decimal"
                  />
                </div>
              </div>
              <div v-else class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <div>
                  <label class="text-base font-medium text-gray-700 mb-2 block">Рік випуску</label>
                  <Skeleton height="42px"/>
                  <p class="text-xs text-gray-500 mt-1">Перевірте рік випуску на фото шильдіка</p>
                </div>
                <div>
                  <label class="text-base font-medium text-gray-700 mb-2 block">Фінальна ставка, USD</label>
                  <Skeleton height="42px"/>
                </div>
              </div>

              <div class="grid grid-cols-1 sm:grid-cols-2 gap-2" v-if="!loader">
                <div class="text-left">
                  <label class="text-base font-medium text-gray-700 mb-2 block">Збір аукціону ($)</label>
                  <input
                      type="number"
                      v-model.number="tax.auction_p"
                      placeholder="Збір аукціону"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      inputmode="decimal"
                      @change="getCustomClearance"
                  />
                  <p class="text-xs text-gray-500 mt-1">Уточнюйте інформацію для Канади</p>
                  <p class="text-xs text-red-500 mt-1" v-if="tax.auction_p === 0 && car.isToyCrashed">Уточнюйте
                    інформацію для toycrashed</p>
                </div>
                <div class="text-left">
                  <label class="text-base font-medium text-gray-700 mb-2 block">Доставка до Klaipeda ({{
                      shipping.portTitle
                    }}) ($)</label>
                  <input
                      type="number"
                      v-model.number="shipping.price"
                      placeholder="Доставка до порту"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      @focusout="() => { isChangedManuallyShipping = true; handlePriceChange() }"
                      inputmode="decimal"
                  />
                  <p class="text-xs text-red-600 mt-1 font-medium">Не входять тимчасові додаткові платежі</p>
                </div>
              </div>
              <div v-else class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <div>
                  <label class="text-base font-medium text-gray-700 mb-2 block">Збір аукціону ($)</label>
                  <Skeleton height="42px"/>
                </div>
                <div>
                  <label class="text-base font-medium text-gray-700 mb-2 block">Доставка до порту</label>
                  <Skeleton height="42px"/>
                </div>
              </div>

              <div  class="grid grid-cols-1 sm:grid-cols-2 gap-2" v-if="!loader && canadaTax > 0">
                <div class="text-left">
                  <label class="text-base font-medium text-gray-700 mb-2 block">HST TAX ($)</label>
                  <input
                      type="number"
                      v-model.number="canadaTax"
                      placeholder="HST TAX"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      inputmode="decimal"
                  />
                </div>
                <div class="w-full">
                  <div class="bg-yellow-50 border-l-4 border-yellow-400 p-3 rounded-lg shadow-sm w-full">
                    <ul class="space-y-1 text-sm text-gray-700">
                      <li class="flex items-start">
                        <span class="text-yellow-600 font-bold mr-2">•</span>
                        <span class="font-semibold">3 auto/cont.</span> + <span class="font-bold text-red-600">$325</span>
                      </li>
                      <li class="flex items-start">
                        <span class="text-yellow-600 font-bold mr-2">•</span>
                        HAZ fee (<span class="italic">electric & hybrid</span>) + <span class="font-bold text-red-600">$250</span> / auto
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="bg-gray-50 p-2 rounded-xl">
                <div class="text-base font-medium text-gray-900 mb-3">Плата за габарити</div>
                <TransportIcons :selected="getSelectedTransportType()" @select="toggleShipping"/>
              </div>

              <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                <label class="flex items-center gap-3 cursor-pointer select-none">
                  <input
                      type="checkbox"
                      :checked="additional.insurence === 1"
                      :value="additional.insurence === 1"
                      v-model="additional.insurence"
                      class="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
                  />
                  <span class="text-base font-medium text-gray-700">
                    Страхування по фото з аукціону (${{ car.priceWithInsurense }})
                  </span>
                </label>
                <button
                    type="button"
                    @click="openInsurensePdf"
                    class="cursor-pointer inline-flex items-center gap-2 text-base font-medium text-primary hover:text-primary/80 focus:outline-none focus:ring-2 focus:ring-primary rounded"
                >
                  Умови страхування
                  <InfoIcon/>
                </button>
              </div>

              <div class="grid grid-cols-1 sm:grid-cols-2 gap-2" v-if="!loader">
                <div class="text-left" v-if="Object.keys(customSetupByUser).length === 0">
                  <label class="text-base font-medium text-gray-700 mb-2 block">Орієнтовна стоянка в Клайпеді
                    ($)</label>
                  <input
                      type="number"
                      v-model.number="car.parkingKl"
                      placeholder="Орієнтовна стоянка в Клайпеді"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      inputmode="decimal"
                  />
                </div>
                <div class="text-left" v-if="customSetupByUser?.fields?.parking">
                  <label class="text-base font-medium text-gray-700 mb-2 block">Заїзд на митницю / євро довідка
                    ($)</label>
                  <input
                      type="number"
                      v-model.number="car.reference"
                      placeholder="Заїзд на митницю / євро довідка"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      inputmode="decimal"
                  />
                </div>
                <div class="text-left">
                  <label class="text-base font-medium text-gray-700 mb-2 block">Експедиція</label>
                  <input
                      type="number"
                      v-model.number="car.expedition"
                      placeholder="Експедиція"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      inputmode="decimal"
                  />
                </div>
              </div>
              <div v-else class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <div v-if="Object.keys(customSetupByUser).length === 0">
                  <label class="text-base font-medium text-gray-700 mb-2 block">Паркінг в Клайпеді на 5 днів</label>
                  <Skeleton height="42px"/>
                </div>
                <div v-if="customSetupByUser?.fields?.parking">
                  <label class="text-base font-medium text-gray-700 mb-2 block">Заїзд на митницю / євро довідка</label>
                  <Skeleton height="42px"/>
                </div>
                <div>
                  <label class="text-base font-medium text-gray-700 mb-2 block">Експедиція</label>
                  <Skeleton height="42px"/>
                </div>
              </div>

              <div v-if="car.engType === 'ELECTRIC'" class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <div class="text-left" v-if="!loader">
                  <label class="text-base font-medium text-gray-700 mb-2 block">Фін. гарантія ($)</label>
                  <input
                      type="number"
                      v-model.number="car.finGuarance"
                      placeholder="Фін. гарантія"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      inputmode="decimal"
                  />
                </div>
                <div v-else>
                  <label class="text-base font-medium text-gray-700 mb-2 block">Фін. гарантія</label>
                  <Skeleton height="42px"/>
                </div>
              </div>

              <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <div class="text-left" v-if="!loader">
                  <label class="text-base font-medium text-gray-700 mb-2 block relative group">
                    <span class="cursor-help">Евакуатор Клайпеда — Львів ($)<span class="text-red-600">*</span></span>
                    <span
                        class="absolute bottom-full left-0 mb-1 hidden group-hover:block bg-red-50 border border-red-200 rounded-md p-2 text-xs text-red-700 max-w-xs z-10">
                      * Кінцева ціна залежить від ситуації на кордоні та вартості ПММ
                    </span>
                  </label>
                  <input
                      type="number"
                      v-model.number="car.shippingKL"
                      placeholder="Евакуатор Клайпеда — Львів"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      inputmode="decimal"
                  />
                </div>
                <div v-else>
                  <label class="text-base font-medium text-gray-700 mb-2 block">Евакуатор Клайпеда — Львів<span
                      class="text-red-600">*</span></label>
                  <Skeleton height="42px"/>
                </div>
                <div class="text-left" v-if="!loaderCustomClearance">
                  <label class="text-base font-medium text-gray-700 mb-2  flex">
                    <span v-if="car.isMoto" class="mr-2 icon-vehicle">
                      🏍
                    </span>

                    <span v-else class="mr-2 icon-vehicle">
                      🚗
                    </span>
                    Розмитнення у
                    {{ moment().format('YYYY') }} році ($)</label>
                  <input
                      type="number"
                      v-model.number="tax.customs_clearance"
                      placeholder="Вартість розмитнення"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      inputmode="decimal"
                  />
                </div>
                <div v-else>
                  <label class="text-base font-medium text-gray-700 mb-2 block">Вартість розмитнення у
                    {{ moment().format('YYYY') }} році</label>
                  <Skeleton height="42px"/>
                </div>
              </div>

              <div class="grid grid-cols-1 sm:grid-cols-2 gap-2" v-if="!loader">
                <div class="text-left">
                  <label class="text-base font-medium text-gray-700 mb-2 block">Сертифікація (середня) ($)</label>
                  <input
                      type="number"
                      v-model.number="car.certP"
                      placeholder="Сертифікація (середня)"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      inputmode="decimal"
                  />
                </div>
                <div class="text-left">
                  <label class="text-base font-medium text-gray-700 mb-2 block">Плата до Пенсійного фонду ($)</label>
                  <input
                      type="number"
                      v-model.number="car.grandPrice"
                      placeholder="Плата до Пенсійного фонду"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      inputmode="decimal"
                  />
                </div>
              </div>
              <div v-else class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <div>
                  <label class="text-base font-medium text-gray-700 mb-2 block">Сертифікація (середня) ($)</label>
                  <Skeleton height="42px"/>
                </div>
                <div>
                  <label class="text-base font-medium text-gray-700 mb-2 block">Плата до Пенсійного фонду ($)</label>
                  <Skeleton height="42px"/>
                </div>
              </div>

              <div class="grid grid-cols-1 sm:grid-cols-2 gap-2" v-if="!loader">
                <div class="text-left">
                  <b><label class="text-base font-medium text-gray-700 mb-2 block">Послуги компанії ($)</label></b>
                  <input
                      type="number"
                      v-model.number="car.planCompany"
                      placeholder="Послуги компанії"
                      class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                      inputmode="decimal"
                  />
                </div>
                <div class="text-right">
                  <div class="  font-medium text-gray-700 mb-2 inline-flex items-center gap-1 relative group">
                    <b><h2 class="cursor-help">Загальна вартість <span class="text-red-600">*</span></h2></b>
                    <span
                        class="absolute bottom-full right-0 mb-1 hidden group-hover:block bg-red-50 border border-red-200 rounded-md p-2 text-xs text-red-700 max-w-xs z-10">
                      * Не враховано комісію за SWIFT‑переказ та евакуатор зі Львова до кінцевого пункту
                    </span>
                  </div>
                  <div class="text-3xl font-extrabold text-gray-900">{{ totalPrice }}$</div>
                </div>
              </div>
              <div v-else class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <div>
                  <label class="text-base font-medium text-gray-700 mb-2 block">Послуги компанії ($)</label>
                  <Skeleton height="42px"/>
                </div>
                <div>
                  <label class="text-base font-medium text-gray-700 mb-2 block">Загальна вартість</label>
                  <Skeleton height="42px"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="max-w-7xl mx-auto" v-else-if="isSubMenu === 'analytics'">
      <div class="bg-white rounded-2xl shadow p-2 sm:p-6">
        <div class="w-full overflow-x-auto">
          <table class="min-w-full border border-gray-200 text-left align-middle">
            <thead>
            <tr class="bg-gray-50 text-gray-700 text-xs sm:text-sm">
              <th class="w-2/12 p-3 border-b">Номер лота</th>
              <th class="w-2/12 p-3 border-b">Фото</th>
              <th class="w-2/12 p-3 border-b">Статус</th>
              <th class="w-1/12 p-3 border-b">Аукціон</th>
              <th class="w-1/12 p-3 border-b">Дата</th>
              <th class="w-2/12 p-3 border-b">Сума</th>
              <th class="w-2/12 p-3 border-b">Продавець</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(history, index) in analytics.histories?.data"
                :key="index"
                class="hover:bg-gray-50 border-b border-gray-100 cursor-pointer transition-colors"
            >
              <td class="p-3 text-sm">{{ history.lot_number }}</td>
              <td class="p-3">
                <img
                    class="w-28 h-20 object-cover rounded-lg border border-gray-100"
                    :src="JSON.parse(history.photo)[0]?.includes('https') ? JSON.parse(history.photo)[0] : 'https://salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png'"
                    :alt="`Лот ${history.lot_number}`"
                />
              </td>
              <td class="p-3 text-sm">{{ history.sale_status }}</td>
              <td class="p-3">
                <span class="inline-flex px-2 py-1 bg-blue-600 text-white text-xs font-medium rounded">{{
                    history.auction_name
                  }}</span>
              </td>
              <td class="p-3 text-sm">{{ moment.unix(history.sale_date).format('YYYY-MM-DD') }}</td>
              <td class="p-3 text-sm font-semibold">${{ history.purchase_price }}</td>
              <td class="p-3 text-sm">{{ history.seller }}</td>
            </tr>
            <tr v-if="(analytics.histories?.data?.length ?? 0) === 0">
              <td colspan="7" class="p-8 text-center text-gray-500 font-medium">Історії на даний момент немає</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
          <div class="bg-gray-50 p-5 rounded-xl border border-gray-200">
            <div class="text-base font-semibold text-gray-800 mb-4">Статистика за останній місяць</div>
            <div class="space-y-3">
              <div class="flex justify-between items-center">
                <div class="text-base font-medium text-gray-700">Середня ціна</div>
                <div class="text-base font-medium">
                  <i class="fa fa-solid fa-arrow-down text-red-500" aria-hidden="true"></i>
                  <i class="fa fa-solid fa-arrow-up text-green-500" aria-hidden="true"></i>
                  ${{ analytics.avgBids?.data?.avg ?? '0' }}
                </div>
              </div>
              <div class="flex justify-between items-center" v-if="analytics?.lotDetails?.data?.price_future">
                <div class="text-base font-medium text-gray-700">Резерв продавця</div>
                <div class="text-base font-medium">$<span class="font-bold">{{
                    analytics?.lotDetails?.data?.price_future
                  }}</span></div>
              </div>
              <div class="flex justify-between items-center">
                <div class="text-base font-medium text-red-600">Мінімальна ставка</div>
                <div class="text-base font-medium text-red-600">
                  <i class="fa fa-solid fa-arrow-down" aria-hidden="true"></i> ${{
                    analytics.avgBids?.data?.min ?? '0'
                  }}
                </div>
              </div>
              <div class="flex justify-between items-center">
                <div class="text-base font-medium text-green-600">Максимальна ставка</div>
                <div class="text-base font-medium text-green-600">
                  <i class="fa fa-solid fa-arrow-up" aria-hidden="true"></i> ${{ analytics.avgBids?.data?.max ?? '0' }}
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <a
                :href="'https://hidecars.vin/en/?vin=' + analytics?.vinCode + '&utm_source=liontrans&utm_medium=referral&utm_campaign=liontst1&vin_clean_offer=i9dqdvqq'"
                target="_blank"
                rel="noopener"
                class="flex items-center justify-between p-2 bg-white border border-teal-500 rounded-xl hover:bg-teal-500 hover:text-white transition-colors"
                v-if="analytics?.vinCode?.length > 0"
            >
              <img :src="require('../../src/assets/hidecars.svg')" alt="HideCars" class="w-24"/>
              <span class="text-base font-medium">Видалити історію VIN</span>
            </a>
            <router-link
                class="inline-flex items-center justify-center p-3 bg-white border border-teal-500 rounded-xl text-teal-600 hover:bg-teal-500 hover:text-white transition-colors text-base font-medium"
                target="_blank"
                :to="{ name: 'vin-decoder', params: { vin: analytics?.vinCode } }"
            >
              Vin Decoder
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-2" v-if="!readedNews">
      <div class="bg-white rounded-2xl p-2 sm:p-6 w-full max-w-2xl max-h-[70vh] overflow-y-auto shadow-xl">
        <div v-html="msgF" class="prose prose-sm max-w-none text-gray-700 mb-2"></div>
        <div class="flex justify-center">
          <custom-btn title="Ознайомився / Ознайомилася" @click="hideNewOnSession"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, defineOptions, getCurrentInstance, onMounted, onUnmounted, reactive, ref, watch} from "vue";
import {useRouter} from "vue-router";
import axios from "axios";
import axiosClient from "@/axios/axios";
import moment from "moment";

import CustomBtn from "@/components/custom-btn";
import {Skeleton} from "vue-loading-skeleton";
import "vue-loading-skeleton/dist/style.css";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import ShareIcons from "@/components/icons/ShareIcons.vue";
import ClearIcon from "@/components/icons/ClearIcon.vue";
import CopyIcon from "@/components/icons/CopyIcon.vue";
import InfoIcon from "@/components/icons/InfoIcon.vue";
import TransportIcons from "@/components/icons/TransportIcons.vue";

import {customSetup, localstorageGet, mapCar, stringToSlug} from "@/helpers/helper";
import helperAuction from "@/helpers/helper-auction";

defineOptions({
  name: "calculator-component",
  components: {CustomBtn, Skeleton, VueSelect, ShareIcons, ClearIcon, CopyIcon, InfoIcon, TransportIcons}
});

const {proxy} = getCurrentInstance();
const router = useRouter();


const user = ref(JSON.parse(localstorageGet('user')));
const readedNews = ref(false);
const analyticsLoading = ref(false);
const isSubMenu = ref("calculator");
const loader = ref(false);
const loaderCustomClearance = ref(false);
const link = ref("");
const courseCurrency = ref(0);
const msg = ref("");
const msgF = ref("");
const images = ref([]);
const dealers = ref([]);
const selectedDealer = ref({});
const openFullText = ref(false);
const isChangedManuallyShipping = ref(false);
const customSetupByUser = ref({});
const parsingData = ref({});

const tax = reactive({
  auction_p: 0,
  customs_clearance: 0,
});

const car = reactive({
  vin_code: "",
  lastFourDigits: "",
  year: 0,
  accCapacity: 0,
  parking: 0,
  expedition: 0,
  engType: "",
  name: "",
  capacity: "",
  cert: "",
  lic: false,
  renta: false,
  insuranceProcent: 0.009,
  priceWithInsurense: 75,
  sellerType: "",
  evacuation: 0,
  certP: 0,
  eng: 0,
  isMoto: false,
  finGuarance: 0,
  planCompany: 0,
  shippingKL: 0,
  saleStatus: "",
  parkingKl: 0,
  reference: 0,
  grandPrice: 0,
  price: 0,
  forAnalytics: {},
});

const canadaTax = ref(0);
const shipping = reactive({
  price: 0,
  priceMain: 0,
  portTitle: ""
});

const additional = reactive({
  insurence: true,
  one: 0,
  two: 0,
  three: 0,
  zero: 0,
});

const analytics = reactive({
  histories: [],
  avgPrice: {},
  vinCode: "",
  vin: "",
});

const goodDocs = computed(() =>
    (car.cert || "").toLowerCase().includes("good") && (car.lic)
);

const totalPrice = computed(() =>
    (
        +car.price +
        +shipping.price +
        +tax.auction_p +
        +tax.customs_clearance +
        +car.grandPrice +
        +car.certP +
        +car.planCompany +
        +car.parkingKl +
        +car.reference +
        +canadaTax.value +
        +car.finGuarance +
        +car.priceWithInsurense +
        +car.shippingKL +
        +car.expedition +
        +car.evacuation
    ).toFixed()
);

const auction = ref(null);

watch(selectedDealer, (val) => {
  if (val && shipping.priceMain) {
    const key = stringToSlug(shipping.portTitle ?? "");
    const extra = (val.taxList && key in val.taxList) ? val.taxList[key] : 0;
    shipping.price = shipping.priceMain + (extra ?? 0);
  } else {
    shipping.price = shipping.priceMain ?? 0;
  }
});

watch(() => additional.insurence, (val) => {
  if (val) {
    const base = (+car.price + +tax.auction_p) * car.insuranceProcent;
    car.priceWithInsurense = (base >= 75 ? base.toFixed(2) : 75);
  } else {
    car.priceWithInsurense = 0;
  }
});

watch(() => car.price, (val) => {
  if (!val) {
    car.grandPrice = 0;
    return;
  }

  calcPensionFund();

  const base = (+car.price + +tax.auction_p) * car.insuranceProcent;
  car.priceWithInsurense = Number((base >= 75 ? base : 75).toFixed());
});

const calcPensionFund = () => {
  if (car.isMoto) {
    car.grandPrice = 40;
    return;
  }

  const usd = (+car.price) * (+courseCurrency.value);
  if (usd < 346830) {
    car.grandPrice = Math.ceil(((+car.price) + (+tax.auction_p) + 1000) * 0.03) + 35;
  } else if (usd >= 346830 && usd < 609580) {
    car.grandPrice = Math.ceil(((+car.price) + (+tax.auction_p) + 1000) * 0.04) + 35;
  } else {
    car.grandPrice = Math.ceil(((+car.price) + (+tax.auction_p) + 1000) * 0.05) + 35;
  }
}

onMounted(async () => {
  customSetupByUser.value = customSetup?.[user.value?.email] ?? {};
  readedNews.value = sessionStorage.getItem("readedNews") === null ? false : sessionStorage.getItem("readedNews");
  getMsg();

  if (user.value?.email === "simple_manager@liontrans.com") {
    await getDealers();
  }
});

onUnmounted(() => {
  const elem = document.getElementById("container");
  if (elem) {
    elem.style.scale = 1;
    elem.style.position = "relative";
    elem.style.top = "0px";
    elem.style.width = "100%";
  }
});

function notify({title, type, text}) {
  proxy?.$notify?.({title, type, text});
}

function handlePriceChange() {
  let add = 0;
  if (additional.zero) add += 0;
  if (additional.one) add += 100;
  if (additional.two) add += shipping.price * 0.5;
  if (additional.three) add += shipping.price;

  if (!isChangedManuallyShipping.value) {
    const basePrice = parsingData.value?.shipping?.cost;
    shipping.price = basePrice + Number(add);
  }
}

function hideNewOnSession() {
  sessionStorage.setItem("readedNews", true);
  readedNews.value = true;
}

function clearCar() {
  isSubMenu.value = "calculator";
  link.value = "";
  analytics.histories = [];
  analytics.avgPrice = {};
  images.value = [];
  tax.auction_p = 0;
  tax.customs_clearance = 0;

  Object.assign(car, {
    vin_code: "",
    lastFourDigits: "",
    year: 0,
    accCapacity: 0,
    parking: 0,
    expedition: 0,
    engType: "",
    name: "",
    capacity: "",
    cert: "",
    lic: false,
    renta: false,
    priceWithInsurense: 75,
    sellerType: "",
    evacuation: 0,
    certP: 0,
    eng: 0,
    planCompany: 0,
    shippingKL: 0,
    saleStatus: "",
    parkingKl: 0,
    grandPrice: 0,
    price: 0,
    locationState: "",
    isToyCrashed: "",
    forAnalytics: {},
  });

  Object.assign(shipping, {price: 0, priceMain: 0, portTitle: ""});
  Object.assign(additional, {insurence: true, one: 0, two: 0, three: 0, zero: 0});
}

function changeMenu(menu) {
  if (link.value === "" || analytics.vinCode === "") return;
  if (!analyticsLoading.value && menu === "analytics") {
    isSubMenu.value = menu;
  } else if (menu === "calculator") {
    isSubMenu.value = menu;
  }
}

function copyToClipboard(text) {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  try {
    document.execCommand("copy");
  } catch (e) {
    console.error("Unable to copy", e);
  }
  document.body.removeChild(textArea);
}

async function calcAuctionFee(auctionName) {
  const {data} = await axiosClient.post("get-fees", {
    auction: auctionName,
    price: car.price ?? 0,
    state: car.locationState ?? "state",
    isToyCrashed: car.isToyCrashed ?? false,
  });

  tax.auction_p = Number(data.fee || 0);
}

const calcCanada = () => {
  if (car.locationCountry === 'CAN') {
    if (car.price + tax.auction_p < 20000) {
      canadaTax.value = 300;
    } else if (car.price + tax.auction_p >= 20000 && car.price + tax.auction_p <= 30000) {
      canadaTax.value = 400;
    } else {
      canadaTax.value = car.price * 0.025;
    }
  }else{
    canadaTax.value = 0;
  }
}

async function getCustomClearance() {
  if (car.isMoto && (!car.capacity || parseFloat(car.capacity) <= 0)) {
    tax.customs_clearance = 0;
    return;
  }

  loaderCustomClearance.value = true;
  calcCanada();

  if (car.price !== 0 && !car.isToyCrashed) {
    if (auction.value === "copart") await calcAuctionFee("copart");
    else await calcAuctionFee("iaai");
  }
  axiosClient
      .post("/get-custom-clearance", {
        auction_fee: tax.auction_p,
        price: car.price,
        year: car.year.toString(),
        isMoto: car.isMoto,
        engine_volume: car.capacity,
        engine_type: car.fEngType,
      })
      .then((response) => {
        courseCurrency.value = response.data.custom_clearance.currencyRate;
        tax.customs_clearance = response.data.custom_clearance.total;
        calcPensionFund();
        loaderCustomClearance.value = false;
      })
      .catch(() => {
        loaderCustomClearance.value = false;
      });
}

function getSelectedTransportType() {
  if (additional.zero) return 'zero';
  if (additional.one) return 'one';
  if (additional.two) return 'two';
  if (additional.three) return 'three';
  return '';
}

function toggleShipping(type) {
  switch (type) {
    case 'none' :
      additional.zero = false;
      additional.two = false;
      additional.three = false;
      additional.one = false;
      break;
    case "one":
      additional.zero = false;
      additional.two = false;
      additional.three = false;
      break;
    case "two":
      additional.one = false;
      additional.three = false;
      additional.zero = false;
      break;
    case "three":
      additional.zero = false;
      additional.two = false;
      additional.one = false;
      break;
    case "zero":
      additional.three = false;
      additional.two = false;
      additional.one = false;
      break;
  }
  additional[type] = additional[type] !== true;
  handlePriceChange();
}

function toggleFullText() {
  openFullText.value = !openFullText.value;
}

function isValidVIN(vin) {
  const regex = /^[A-HJ-NPR-Z\d]{17}$/;
  return regex.test(vin);
}

async function parseLink() {
  if (link.value === "") {
    notify({title: "Системне повідомлення!", type: "error", text: "Вставте лінку!"});
    return;
  }
  auction.value = link.value.includes("copart") ? "copart" : "iaai";
  analyticsLoading.value = false;
  isSubMenu.value = "calculator";

  if (isValidVIN(link.value)) {
    await carAnalyticsByVin(link.value);
    return;
  }

  loader.value = true;

  axiosClient
      .post("parse", {
        auction: auction.value,
        destination: "lithuania",
        url: link.value,
      })
      .then((response) => {
        notify({title: "Системне повідомлення!", type: "success", text: "Успішний парс машини!"});
        parsingData.value = response.data;

        images.value = response.data?.info?.images ?? [];
        Object.assign(car, mapCar(response.data.info, user.value));

        const extra = customSetupByUser.value;
        const baseCost = Number(response.data.shipping?.cost ?? 0);
        if (car.isMoto) {
          toggleShipping('zero');
          car.expedition = 260;
          car.shippingKL = 550;
          car.grandPrice = 40;
          if (car.isToyCrashed) {
            tax.auction_p = 0;
          }
        } else {
          toggleShipping('none');
        }
        calcCanada()
        if (extra && Object.keys(extra).length > 0) {
          shipping.price = baseCost > 0 ? baseCost + Number(extra.shipping ?? 0) : baseCost;
          shipping.priceMain = shipping.price;
        } else {
          shipping.price = baseCost;
          shipping.priceMain = baseCost;
        }
        shipping.portTitle = response.data.shipping?.port ?? "";

        loader.value = false;
        if (car.price > 0) {
          getCustomClearance();
        }
        carAnalytics();
      })
      .catch((e) => {
        if (e.response) {
          canadaTax.value = 0;
          analyticsLoading.value = true;
          loader.value = false;
          notify({title: "Site event!", type: "error", text: "Спробуй пізніше, здається щось не працює!"});
        }
      });
}

function openInsurensePdf() {
  window.open("pdf/2025%20Умови%20страхування%20Lion%20Trans.pdf", "_blank")?.focus();
}

function copyVin() {
  notify({title: "Системне повідомлення!", type: "success", text: "Він код скопійовано в буфер обміну!"});
  copyToClipboard(car.vin_code + car.lastFourDigits);
}

async function carAnalyticsByVin(vin) {
  analytics.vinCode = vin;
  const part1 = vin.slice(0, -6);
  car.vin_code = part1;
  car.lastFourDigits = vin.replace(car.vin_code, "");
  analytics.histories = await helperAuction.getVinHistories(vin);
  analyticsLoading.value = true;
  notify({
    title: "Системне повідомлення!",
    type: "success",
    text: "Аналіз машини завершенно, можете переглянути вкладку 'Аналітика Авто'!"
  });
}

async function carAnalytics() {
  analyticsLoading.value = true;
  const vinResponse = await helperAuction.getVin(car.lotId, car.salvageId, auction.value);
  analytics.vinCode = vinResponse.data.vin;
  const part1 = car.vin_code;
  car.lastFourDigits = vinResponse.data.vin.replace(part1, "");
  analytics.lotDetails = await helperAuction.getLotDetails(vinResponse.data.vin, car.lotId, auction.value);
  analytics.histories = await helperAuction.getVinHistories(vinResponse.data.vin);

  const analitycsData = {...car.forAnalytics};
  if (car.engType !== "ELECTRIC") {
    const m = car.forAnalytics.engine_volume?.match?.(/(\d+\.\d+)/);
    if (m && m[0]) analitycsData.engine_volume = m[0];
  } else {
    delete analitycsData.engine_volume;
  }
  analytics.avgBids = await helperAuction.getAvgBids(analitycsData);
  analyticsLoading.value = false;

  notify({
    title: "Системне повідомлення!",
    type: "success",
    text: "Аналіз машини завершенно, можете переглянути вкладку 'Аналітика Авто'!"
  });
}

function share() {
  const routeData = router.resolve({
    name: "share-result",
    query: {
      name: car.name,
      vin: car.vin_code,
      last_4_digits: car.lastFourDigits,
      year: car.year,
      price: car.price,
      auction_p: tax.auction_p,
      shipping: shipping.price,
      shippingKL: car.shippingKL,
      shippingType: additional.one ? "one" : (additional.two ? "two" : (additional.three ? "three" : (additional.zero ? "zero" : ""))),
      insurence: additional.insurence > 0,
      parkingKl: car.parkingKl,
      expedition: car.expedition,
      evacuation: car.evacuation,
      custom: tax.customs_clearance,
      certP: car.certP,
      grandPrice: car.grandPrice,
      planCompany: car.planCompany,
      totalPrice: totalPrice.value
    }
  });

  const url = window.location.protocol + "//" + window.location.host + routeData.href;
  copyToClipboard(url);
  notify({title: "Системне повідомлення!", type: "success", text: "Посилання скопійоване, вставте в чат отримувачу!"});
}

function getMsg() {
  axios.get("https://back-end.mad-dev.pp.ua/shipping-msg")
      .then(({data}) => {
        msg.value = data.value;
        msgF.value = data.value;
        msg.value = msg.value.split("<br>", 3).join("<br>") + "<br>.........";
      })
      .catch(({response}) => console.log(response));
}

async function getDealers() {
  const {data} = await axiosClient.get("/dealers");
  dealers.value = data;
}

function changeDealer() {
  console.log(selectedDealer.value);
}

</script>